export default __webpack_public_path__ + "static/media/Mr_Barry.44ab703b.png";